import { NavLinks } from '@montebravo.tech/design-system-navigation';
import { Roles } from '../../core/auth/roles';

type Department = {
    id: string;
    roles: Roles[];
};

export const AssetDepartment: Department = {
    id: 'assets',
    roles: [Roles.Asset],
};

export const BIDepartment: Department = {
    id: 'business-intelligence',
    roles: [Roles.BusinessIntelligence],
};

export const WealthDepartment: Department = {
    id: 'wealth-services',
    roles: [Roles.WealthService],
};

export const BackRvdDepartment: Department = {
    id: 'back-rvd',
    roles: [Roles.BackRvd],
};

export const PerformanceAndProjectsDepartament: Department = {
    id: 'performance-and-projects',
    roles: [Roles.PerformanceAndProjects],
};

export const IPODepartment: Department = {
    id: 'ipos',
    roles: [Roles.Ipo],
};

export const CambioDepartment: Department = {
    id: 'cambio',
    roles: [Roles.Cambio],
};

export const FinancialPlanningDepartment: Department = {
    id: 'financial-planning',
    roles: [Roles.FinancialPlanning],
};

export const ConsolidationDepartment: Department = {
    id: 'consolidation',
    roles: [Roles.Consolidation],
};

export const ImportTrackingDepartment: Department = {
    id: 'import-tracking',
    roles: [Roles.Consolidation],
};

export const DepartmentsMap = {
    [AssetDepartment.id]: AssetDepartment,
    [BIDepartment.id]: BIDepartment,
    [WealthDepartment.id]: WealthDepartment,
    [BackRvdDepartment.id]: BackRvdDepartment,
    [PerformanceAndProjectsDepartament.id]: PerformanceAndProjectsDepartament,
    [IPODepartment.id]: IPODepartment,
    [CambioDepartment.id]: CambioDepartment,
    [FinancialPlanningDepartment.id]: FinancialPlanningDepartment,
    [ConsolidationDepartment.id]: ConsolidationDepartment,
    [ImportTrackingDepartment.id]: ImportTrackingDepartment,
};

export const navLinks: NavLinks = [
    {
        id: WealthDepartment.id,
        icon: 'asset-allocation',
        label: 'Serv. Patrimoniais',
        link: `/app/${WealthDepartment.id}`,
    },
    {
        id: ImportTrackingDepartment.id,
        icon: 'upload',
        label: 'Importações',
        link: `/app/${ImportTrackingDepartment.id}`,
    },
    {
        id: BIDepartment.id,
        icon: 'panels',
        label: 'BI',
        link: `/app/${BIDepartment.id}`,
    },
    {
        id: AssetDepartment.id,
        icon: 'dashboard',
        label: 'Asset',
        link: `/app/${AssetDepartment.id}`,
    },
    {
        id: BackRvdDepartment.id,
        icon: 'helpdesk',
        label: 'Back RVD',
        link: `/app/${BackRvdDepartment.id}`,
    },
    {
        id: PerformanceAndProjectsDepartament.id,
        icon: 'performance',
        label: 'Performance & Projetos',
        link: `/app/${PerformanceAndProjectsDepartament.id}`,
    },
    {
        id: IPODepartment.id,
        icon: 'helpdesk',
        label: 'Listed Funds - IPO',
        link: `/app/${IPODepartment.id}`,
    },
    {
        id: CambioDepartment.id,
        icon: 'chart2',
        label: 'Câmbio',
        link: `/app/${CambioDepartment.id}`,
    },
    {
        id: FinancialPlanningDepartment.id,
        icon: 'chart3',
        label: 'Planejamento Financeiro',
        link: `/app/${FinancialPlanningDepartment.id}`,
    },
    {
        id: ConsolidationDepartment.id,
        icon: 'chart1',
        label: 'Consolidação',
        link: `/app/${ConsolidationDepartment.id}`,
    },
];
